import { Prompt } from 'react-router-dom';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { Container } from 'reactstrap';
import entityComposition from '../common/classes/entityComposition';
import { editPermissionSelector } from '../common/classes/permissions';
import SectionPanel from '../common/containers/sectionPanel';
import routeHelper from '../common/classes/routeHelper';
import DocumentGeneral from './documentGeneral';
class Document extends Component {
  constructor(props) {
    const {
      match
    } = props;
    if (!match.params || !match.params.id) {
      throw new Error('props.match.params.id is required');
    }
    super(props);
    this.handleSave = this.handleSave.bind(this);
    this.onBack = routeHelper.updateURL.bind(routeHelper, '/library');
  }
  componentDidMount() {
    const {
      documentActions,
      match
    } = this.props;
    documentActions.serverShow(match.params.id);
  }
  handleSave() {
    const {
      documentActions,
      document
    } = this.props;
    documentActions.serverPatch(document.active);
  }
  render() {
    const {
      document: {
        active,
        pendingChanges,
        loading
      },
      match,
      canEdit
    } = this.props;
    const renderNow = !active || _.isUndefined(active.id) || match.params.id !== active.id; // Make sure the new active matches the props

    return /*#__PURE__*/React.createElement(Container, null, renderNow ? /*#__PURE__*/React.createElement("span", null, "loading...") : /*#__PURE__*/React.createElement(SectionPanel, {
      isPending: pendingChanges,
      isSaveDisabled: loading || !pendingChanges,
      onBack: this.onBack,
      onSave: this.handleSave,
      name: active.displayName,
      showSave: canEdit
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        height: '1000px'
      }
    }, /*#__PURE__*/React.createElement(Prompt, {
      when: pendingChanges,
      message: location => routeHelper.transitionAsync(this, 'document', location)
    }), /*#__PURE__*/React.createElement(DocumentGeneral, null))));
  }
}
Document.propTypes = {
  document: PropTypes.shape({
    active: PropTypes.shape({
      displayName: PropTypes.string,
      id: PropTypes.string
    }),
    pendingChanges: PropTypes.bool,
    loading: PropTypes.bool
  }).isRequired,
  // document redux store
  documentActions: PropTypes.shape({
    serverPatch: PropTypes.func,
    serverShow: PropTypes.func
  }).isRequired,
  // document redux actions
  canEdit: PropTypes.bool.isRequired,
  // permissions bools
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string
    }).isRequired
  }).isRequired
};
export { Document as TestDocument };
export default entityComposition(Document, ['document'], {
  canEdit: state => editPermissionSelector('document')(state)
});